import React, {useState} from 'react'
import '../styles/basicLayout.css'
import back from "../assets/back.png";
import Clock from "../assets/clock-icon.png";
import action from "../assets/action.png";
import action2 from "../assets/action2.png";
import Setter from "../components/Setter";
import { MIN_GRILL_TEMP_F, MIN_PROD_TEMP_F, MIN_TIME_S } from "../utils/constants";
import ProductTemp from "../components/ProductTemp";

export const settings = {
  PRODUCT_TEMP: "PRODUCT_TEMP",
  GRILL_TEMP: "GRILL_TEMP",
  TIME: "TIME"
}

export default function Layout() {
  
  const [setting, setSetting] = useState(settings.PRODUCT_TEMP)
  const [recipe, setRecipe] = useState({
    name: 'New recipe',
    stages: [
      {
        id: 0,
        product_temperature_f: MIN_PROD_TEMP_F,
        grill_temperature_f: MIN_GRILL_TEMP_F,
        time_s: MIN_TIME_S,
      }
    ],
    category: null,
    activeStage: 0,
  })
  return (
    <>
      <header>
        <div className="left">
          <img className="btn" width="80px" src={back} alt="" />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center">
          <h2>Program Mode</h2>
        </div>
        <div className="right">

          <img
            className="btn"
            width="60px"
            src={action}
            alt=""
          />
          <img
            className="btn"
            width="60px"
            src={Clock}
            alt=""
          />
          <img
            className="btn"
            width="60px"
            src={action2}
            alt=""
          />
        </div>
      </header>
      {/* <nav>Nav</nav> */}
      <article>
        <div className="left">lala</div>
        <div className="center">
          <ProductTemp setting={setting} stage={recipe.stages[recipe.activeStage]} />
        </div>
        <div className="right">
          <Setter setting={setting} stage={recipe.stages[recipe.activeStage]}  />
        </div>
      </article>
      {/* <aside>Aside</aside> */}
    </>
  )
}